import { useMutation, useQuery, useQueryClient } from '@tanstack/react-query';
import { api } from 'modules/global/adapters';
import { BulkReleaseRightActionRequest } from 'modules/global/adapters/crpAPI';
import { declineReleaseRightKeys } from './queryKeys';

export const useGetPendingContainers = () => {
  return useQuery(declineReleaseRightKeys.getPendingContainersForReleaseRightAction(), () =>
    api.containers.getPendingContainersForReleaseRightAction()
  );
};

export const usePostContainersDecline = () => {
  const queryClient = useQueryClient();

  return useMutation(declineReleaseRightKeys.postContainersDecline(), {
    mutationFn: (data: BulkReleaseRightActionRequest) =>
      api.releaserights.postContainersDecline(data),
    onSuccess: () => {
      // We will invalidate all queries that are used in the update terminal action
      // not a specific filtered one
      queryClient.invalidateQueries(declineReleaseRightKeys.containersForUpdateRoot());
    },
  });
};
